import { IconButton } from "@/DesignSystem";

import PlusIconSvg from "@/DesignSystem/Atoms/Icons/Types/PlusThin/plus-thin-bold.svg";

interface IAddCareElementIconButtonProps {
    id?: string;
    dataCy?: string;
    disabled?: boolean;
    onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

function AddCareElementIconButton({
    id,
    dataCy,
    disabled = false,
    onClick
}: Readonly<IAddCareElementIconButtonProps>): JSX.Element {
    return (
        <IconButton
            id={id}
            dataCy={dataCy}
            disabled={disabled}
            onClick={e => {
                e.stopPropagation();
                onClick?.(e);
            }}
            size="sm"
            variant="neutral"
            category="secondary"
        >
            <PlusIconSvg />
        </IconButton>
    );
}

export { AddCareElementIconButton };
